
export default {
  props: { blog: { type: Object, required: true } },

  computed: {
    blogDescription() {
      const description = this.blog.description ?? "";

      return description.length > 500
        ? description.substring(0, 500) + " ....."
        : description;
    },
    tags() {
      return this.blog.tags.filter(tag => tag.startsWith("Blog_"));
    },
    imgProps() {
      return {
        src: this.blog.imageUrl,
        alt: `Image for ${this.blog.title}`,
        height: 275,
        width: 604,
        fit: "cover",
        modifiers: { crop: "entropy" },
      };
    },
  },
};
